import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import "./css/ScrollToTopButton.css";

const ScrollToTopButton = () => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 200) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	return (
		<button
			onClick={scrollToTop}
			className={`scroll-to-top ${isVisible ? "visible" : ""}`}
		>
			<ArrowUp size={24} />
		</button>
	);
};

export default ScrollToTopButton;
